<template>
  <div class="rule-item">
    <div class="rule-header-wrapper">
      <div class="rule-header">
        <span class="required" v-if="isMandatory">*</span>
        <span class="label">提前退车</span>
        <i class="el-icon-delete delete-btn" @click="emit('remove')" v-if="!isMandatory"></i>
      </div>
      <div class="desc">承租人需提前申请，并支付相应的违约金。</div>
    </div>
    <div class="ai-box" v-if="tip">
      <span class="ai-tag">AI</span>
      <span class="ai-text">{{ tip }}</span>
    </div>
    <div class="rule-body">
      <el-radio-group :value="modelValue.returnCarDeliveryFeeType" @input="updateField('returnCarDeliveryFeeType', $event)">
        <el-radio :label="0">不限制（无违约金）</el-radio>
        <el-radio :label="1">需支付违约金</el-radio>
      </el-radio-group>
      <div class="indent-block" v-if="modelValue.returnCarDeliveryFeeType === 1">
        <div class="flex-row">
          <span class="label-text">需提前申请，并支付违约金</span>
          <el-form-item :prop="`${propPrefix}.returnCarDeliveryFee`" :rules="modelValue.returnCarDeliveryFeeType === 1 ? getRules(10000) : []" class="flex-input" style="margin: 0 5px; margin-bottom: 0;">
            <el-input
              :value="modelValue.returnCarDeliveryFee"
              placeholder="请输入"
              size="small"
              v-number:float
              @input="updateField('returnCarDeliveryFee', $event)"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <span class="label-text">+ 剩余租期总租金的</span>
          <el-form-item
            :prop="`${propPrefix}.returnCarDeliveryFeePercent`"
            class="flex-input" style="margin: 0 5px; margin-bottom: 0;"
            :rules="getRules(100, 0)">
            <el-input
              :value="modelValue.returnCarDeliveryFeePercent"
              placeholder="请输入"
              size="small"
              v-integer-number
              @input="updateField('returnCarDeliveryFeePercent', $event)"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { requiredRule, getRules } from './utils'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  propPrefix: {
    type: String,
    required: true,
  },
  tip: {
    type: String,
    default: '',
  },
  isMandatory: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'remove'])

const updateField = (key, value) => {
  const newItem = { ...props.modelValue, [key]: value }
  emit('update:modelValue', newItem)
}
</script>

<style lang="scss" scoped>
@import './rules.scss';
</style>
